import { useFormatters } from "@/workspace/values"

/**
 * Workbook dates for people: "Aug 1, 2026 · 11:56". A store timestamp keeps its own wall-clock time
 * (what the customer saw in the store's time zone); the raw ISO text stays in lineage and tooltips.
 */
export function formatDay(tag: string, date: string | null): string | null {
  if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return date
  const d = new Date(`${date}T00:00:00Z`)
  if (Number.isNaN(d.getTime())) return date
  return new Intl.DateTimeFormat(tag, { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" }).format(d)
}

export function formatStamp(tag: string, timestamp: string | null): string | null {
  const m = timestamp ? /^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})/.exec(timestamp) : null
  if (!m?.[1]) return timestamp
  const day = formatDay(tag, m[1])
  return day === m[1] ? timestamp : `${day} · ${m[2]}:${m[3]}`
}

export function useWorkbookDates() {
  const { tag } = useFormatters()
  return { day: (date: string | null) => formatDay(tag, date), stamp: (timestamp: string | null) => formatStamp(tag, timestamp) }
}
